"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchQueries = exports.searchQueryKeys = void 0;
const search_api_1 = require("./search.api");
exports.searchQueryKeys = {
    all: () => ['search'],
    SearchSuggestions: (params) => [...exports.searchQueryKeys.all(), 'SearchSuggestions', params],
    SearchContentSuggestion: (params) => [...exports.searchQueryKeys.all(), 'SearchContentSuggestion', params],
};
const searchQueries = (apiOptions) => ({
    getSearchSuggestions: (params, options = {}) => (Object.assign(Object.assign({}, options), { queryKey: exports.searchQueryKeys.SearchSuggestions(params), queryFn: () => (0, search_api_1.getSearchSuggestions)(apiOptions, params) })),
    getSearchContentSuggestion: (params, options = {}) => (Object.assign(Object.assign({}, options), { queryKey: exports.searchQueryKeys.SearchContentSuggestion(params), queryFn: () => (0, search_api_1.getSearchContentSuggestion)(apiOptions, params) })),
});
exports.searchQueries = searchQueries;
//# sourceMappingURL=search.queries.js.map